import React from 'react';
import { StructuredData } from '..';

export function BodyAreasStructuredData({ areaName, areaDescription, areaImage, areaUrl }) {
    return (
        <StructuredData>
            {{
                '@context': 'https://schema.org',
                '@type': 'Service',
                'name': areaName,
                'description': areaDescription,
                'provider': {
                    '@type': 'Organization',
                    'name': 'Milan Laser Hair Removal',
                    'url': `https://milanlaser.com`,
                    'logo': `https://milanlaser.com/static/Milan-Logo-Blue-4e6f080e8dbe7fe7d1a1008cd94b73a4.webp`,
                    'contactPoint': {
                        '@type': 'ContactPoint',
                        'telephone': '+1-833-667-2967',
                        'contactType': 'Customer Service'
                    }
                },
                'areaServed': {
                    '@type': 'Place',
                    'name': 'United States'
                },
                'serviceType': 'Laser Hair Removal',
                'image': areaImage,
                'url': areaUrl,
            }}
        </StructuredData>
    );
}
